import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientService } from 'core/client.service';
import { SecurityService } from 'core/security.service';

@Component({
  selector: 'samplicity-app-content',
  templateUrl: './app-content.component.html',
  styleUrls: ['./app-content.component.scss']
})
export class AppContentComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    private securityService: SecurityService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.securityService.getUserAccess().then((user) => {
        const tenants = user.tenants.map((x) => x.toString());
        const index = tenants.indexOf(params.tenantId);
        if (index > -1) {
          this.clientService.changeClient(params.tenantId);
        } else {
          this.clientService.changeClient(user.defaultTenantId);
        }
      });
    });
  }

}
